import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#041952",
  "fill-rule": "evenodd",
  d: "M1.042 3.833c0-.621.503-1.125 1.125-1.125h5.148c.269 0 .528.096.732.271l2.6 2.23h7.186c.622 0 1.125.503 1.125 1.124v9.834c0 .62-.503 1.125-1.125 1.125H2.167a1.125 1.125 0 0 1-1.125-1.125zm1.25.125v4.584h15.416V6.458h-7.106a1.13 1.13 0 0 1-.733-.27l-2.6-2.23zm15.416 5.834H2.292v6.25h15.416z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }